import React from 'react';
import { Row, Col } from 'react-bootstrap';
import clsx from 'clsx';
import Carousel from 'react-multi-carousel';

import ReadMore from '../../../components/ReadMore';
import QuoteIcon from '../../../ui-core/Quote';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { getDisplayType } from '../../../utils/helpers';
import { CAROUSEL_BREAKPOINT } from '../../../constants/app';

import './style.css';

const Testimonial = () => {
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const isIpadScreen = displayType === 'ipad';
  const testimonials = [
    {
      testimonial: `“Thank you so much for this challenge, <b>my hip and shoulder mobility has improved so much.</b> Hips were huge. I feel better and can workout with <u>more range of motion pain free</u>!!”`,
      name: 'Jen',
    },
    {
      testimonial: `"I've got 2 small kids and after having my second, I experienced <b>leaking</b> when exercising when I would do a lot of jumps or that type of thing. It wasn't until your 30 Days of Release & Recovery program and the core work really working on the <b>breathing</b> and <b>pelvic floor activation</b> that I really understood what I should be doing. So today, I did 100 skips and <u><b>no leaking</b></u>. None whatsoever! I wasn't even worried about it. Such a win."`,
      name: 'Anonymous',
    },
    {
      testimonial: `"I used to get really bad <b>constant pain</b> under my right scapula, and since I did the first GFMB Challenge, <b>it has pretty well gone away!</b> I know now when I need to do my upper body mobility, so I do it, and if it's hurting (which is rare now) within a day or two it gets better again. Compared to before where it basically hurt all the time! Along with hips, neck, knees, etc etc... haha. <u>I've learned SO much.</u> I just need to keep it up when life gets busy, and the GFMB challenge this month HAS <b>helped get me back into a routine</b>."`,
      name: 'Julie',
    },
    {
      testimonial: `"I have loved the challenge and cannot believe how much I have benefited. <b>I have not reached for the daily dose of Aleve since starting</b>. Seriously a huge different in how I feel every day. Thank you thank you!"`,
      name: 'Julie',
    },
    {
      testimonial: `"Thank you for this challenge. I have noticed change for the better. <b>My lower back no longer hurts when I get out of bed</b>. I want to continue these workouts."`,
      name: 'Vicki',
    },
  ];

  const renderTestimonials = () => {
    const testimonialsOutput = testimonials?.map((item, index) => (
      <div
        key={`testimonial-${index + 1}`}
        className="item postion-relative d-flex flex-column justify-content-between"
      >
        {isMobileScreen ? (
          Array.from({ length: 4 }).map((_, index) => (
            <div
              style={{
                right: '40px',
                top: '-15px',
              }}
              className="position-absolute"
              key={`testimonial-item-${index + 1}`}
            >
              <QuoteIcon key={`quote-icon-${index + 1}`} />
            </div>
          ))
        ) : (
          <div
            style={{
              right: '40px',
              top: '-15px',
            }}
            className="position-absolute"
          >
            <QuoteIcon />
          </div>
        )}
        <ReadMore
          readMoreText="Read More"
          readLessText="Less"
          text={item.testimonial}
          textLimit={isIpadScreen ? 150 : isMobileScreen ? 165 : 195}
        />
        <p className="name-para">{item.name}</p>
      </div>
    ));
    return testimonialsOutput;
  };

  return (
    <section
      className={clsx(
        !isMobileScreen
          ? 'home-testimonial full-body-testimonials'
          : 'pt-5 home-testimonial full-body-testimonials',
      )}
    >
      <div className="container">
        <Row>
          <Col>
            <h3 className="text-center h-3 ms-5 me-5 sec-head">Testimonials</h3>
          </Col>
        </Row>
        <Row className={clsx('px-lg-5', isMobileScreen && 'mt-3')}>
          <Col className="position-relative">
            {isMobileScreen ? (
              <div className="doctors-advice d_c">{renderTestimonials()}</div>
            ) : (
              <Carousel
                responsive={CAROUSEL_BREAKPOINT}
                className="doctors-advice d_c"
                showDots={true}
                swipeable={isMobileScreen || isIpadScreen}
                draggable={isMobileScreen || isIpadScreen}
              >
                {renderTestimonials()}
              </Carousel>
            )}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Testimonial;
